var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      this.showAffairesTableau
        ? _c(
            "button",
            {
              staticClass: "btn btn-orezo dashboard-btn-back",
              on: { click: _vm.retour }
            },
            [
              _c("i", { staticClass: "fa fa-chevron-left" }),
              _vm._v(" Retour\n    ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !this.showAffairesTableau
        ? _c("div", { staticClass: "row dashboard-titre" }, [
            _c("h1", [_vm._v("TABLEAU DES AFFAIRES")])
          ])
        : _c("div", { staticClass: "row dashboard-titre" }, [
            _c("h1", [_vm._v(_vm._s(this.groupeToShow.groupeLibelle))])
          ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      !_vm.showAffairesTableau
        ? _c("div", { staticClass: "box-dashboard" }, [
            !this.data.showLoader
              ? _c(
                  "div",
                  _vm._l(this.data.phaseGroupes, function(
                    phaseGrps,
                    indexPhase
                  ) {
                    return _c("div", [
                      _c("div", { staticClass: "box-phases" }, [
                        _c("span", { staticClass: "phase-libelle" }, [
                          _vm._v(_vm._s(phaseGrps.phaseLibelle))
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "box-groupes" },
                          _vm._l(phaseGrps.groupes, function(groupe, indexGrp) {
                            return _c(
                              "div",
                              {
                                staticClass: "box-groupe",
                                on: {
                                  click: function($event) {
                                    return _vm.loadAffairesTaches(
                                      indexPhase,
                                      indexGrp
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(groupe.groupeLibelle) +
                                    "\n                            "
                                ),
                                _c(
                                  "span",
                                  {
                                    class: [
                                      "task-to-do-count",
                                      groupe.taskToDoCount > 99
                                        ? "task-to-do-count-small"
                                        : ""
                                    ],
                                    attrs: {
                                      "data-count": groupe.taskToDoCount
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          groupe.taskToDoCount > 99
                                            ? "99+"
                                            : groupe.taskToDoCount
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ])
                  }),
                  0
                )
              : _c("div", [
                  _c("i", {
                    staticClass: "fa fa-3x fa-spinner fa-pulse fa-fw",
                    staticStyle: { "vertical-align": "middle" }
                  })
                ])
          ])
        : _c("dashboard-tableau-affaires", {
            attrs: { groupe: this.groupeToShow }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dea00a8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dea00a8a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Dashboard/Components/Dashboard.vue
// module id = 529
// module chunks = 0